import { map } from 'lodash';
import { setPrimaryCaregiver } from './actions';
import EmergencyContactService from './EmergencyContactService';
import PrimaryCaregiverService from './PrimaryCaregiverService';
import { currentPatientIdSelector } from '../patient';
import { toAddressRequest } from '../util';

// Helpers
const toEmergencyContactRequest = (emergencyContacts, patientId) =>
  map(emergencyContacts, caregiver => toCaregiverRequest(caregiver, patientId));

const toCaregiverRequest = (
  {
    addressId,
    addressState,
    city,
    email,
    firstName,
    id,
    lastName,
    primaryPhoneNumber,
    relationship,
    secondaryStreetAddress,
    streetAddress,
    zipCode,
    notes,
  },
  patientId,
) => ({
  ...toAddressRequest({
    addressId,
    addressState,
    city,
    secondaryStreetAddress,
    streetAddress,
    zipCode,
  }),
  email,
  firstName,
  id,
  lastName,
  patientId,
  notes,
  patientRelationship: relationship,
  phone: primaryPhoneNumber,
});

const toRequest = (data, patientId) => ({
  ...toCaregiverRequest(data, patientId),
  emergencyContacts: toEmergencyContactRequest(
    data.emergencyContacts,
    patientId,
  ),
});

// Thunks
const fetchPrimaryCaregiverAsync = () => (dispatch, getState) => {
  const state = getState();
  const patientId = currentPatientIdSelector(state);

  return Promise.all([
    dispatch(PrimaryCaregiverService.getByPatientId(patientId)),
    dispatch(EmergencyContactService.getByPatientId(patientId)),
  ]).then(([primaryCaregiver, emergencyContacts]) => {
    return dispatch(
      setPrimaryCaregiver({
        ...primaryCaregiver,
        emergencyContacts,
      }),
    );
  });
};

const updatePrimaryCaregiverAsync = primaryCaregiver => (
  dispatch,
  getState,
) => {
  const state = getState();
  const patientId = currentPatientIdSelector(state);

  return dispatch(
    PrimaryCaregiverService.update(
      primaryCaregiver.id,
      toRequest(primaryCaregiver, patientId),
    ),
  ).then(() => dispatch(setPrimaryCaregiver(primaryCaregiver)));
};

const createPrimaryCaregiverAsync = primaryCaregiver => (
  dispatch,
  getState,
) => {
  const state = getState();
  const patientId = currentPatientIdSelector(state);

  return dispatch(
    PrimaryCaregiverService.create(toRequest(primaryCaregiver, patientId)),
  );
};

const savePrimaryCaregiverAsync = primaryCaregiver => {
  return !!primaryCaregiver.id
    ? updatePrimaryCaregiverAsync(primaryCaregiver)
    : createPrimaryCaregiverAsync(primaryCaregiver);
};

export { fetchPrimaryCaregiverAsync, savePrimaryCaregiverAsync };



// WEBPACK FOOTER //
// ./src/lib/dataLayer/primaryCaregiver/thunks.js